module.exports = {
  article: `<h4 class="mb-20 mt-32 bl-text bl-text--subheading-18">Tentang Edukarier</h4>
    <h2 class="mb-20 mt-32 bl-text bl-text--heading-28">Apa Itu EduKarier?</h2>
    <p class="mb-20 bl-text bl-text--body-16">EduKarier adalah platform marketplace yang menyediakan beragam kursus dan pelatihan terdepan untuk membantu Anda meraih karier yang cemerlang di masa depan. Kami menawarkan berbagai program mulai dari bootcamp persiapan CPNS yang dirancang khusus, hingga berbagai kursus sertifikasi lain yang relevan dan diakui secara nasional. Dengan fokus pada kualitas materi, pengajar berpengalaman, dan metode pembelajaran yang praktis.</p>
    <p class="mb-20 bl-text bl-text--body-16">EduKarier siap menjadi teman kalian semua dalam meningkatkan kompetensi dan keterampilan yang dibutuhkan di dunia kerja. Bersama EduKarier, wujudkan impian karier Anda dengan persiapan yang matang dan kesempatan belajar tanpa batas!</p>
  `,
  faqs: [
    {
      question: '<h3 class="ml-16 bl-text bl-text--subheading-20">Bagaimana cara membeli kelas di EduKarier?</h3>',
      answer: `
        <p class="mb-20 ml-16 bl-text bl-text--body-16">Berikut ini merupakan tata cara membeli kelas di EduKarier:</p>
        <ol class="ml-16 pl-16 mb-0">
          <li>
            <p class="bl-text bl-text--body-16">Masuk ke Situs atau Aplikasi Bukalapak: Buka situs Bukalapak di browser Anda atau gunakan aplikasi Bukalapak di perangkat mobile Anda. Login ke akun Bukalapak Anda. Jika belum memiliki akun, Anda bisa mendaftar terlebih dahulu.</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Cari Kelas: Di halaman utama Bukalapak, cari "EduKarier" di kolom pencarian. Atau klik ikon EduKarier pada halaman utama</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Pilih Kelas: Telusuri pilihan pelatihan yang ada. Anda bisa menggunakan filter atau kategori untuk menemukan pelatihan yang sesuai dengan kebutuhan Anda. Klik pada pelatihan yang Anda minati untuk melihat detail lebih lanjut</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Beli Pelatihan: Setelah memilih pelatihan yang diinginkan, klik tombol "Beli". Anda akan diarahkan ke halaman pembayaran.</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Pilih Metode Pembayaran: Pada halaman pembayaran, Anda akan melihat opsi untuk memilih metode pembayaran.</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Konfirmasi Pembayaran: Setelah memilih metode bayar, periksa kembali detail pesanan Anda. Klik "Bayar" atau "Lanjutkan" untuk menyelesaikan proses pembayaran.</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Akses Pelatihan: Setelah pembayaran berhasil, Anda akan menerima konfirmasi melalui email atau notifikasi di aplikasi Bukalapak. Anda bisa mengakses pelatihan yang telah dibeli melalui menu "Transaksi" atau "Pesanan Saya" di akun Bukalapak Anda.</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Mulai Pelatihan: Ikuti instruksi yang diberikan untuk memulai pelatihan. Biasanya, Anda akan diarahkan ke platform penyedia pelatihan untuk mengakses materi dan mengikuti kelas.</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Jika mengalami kendala, Anda bisa menghubungi layanan pelanggan Bukalapak atau mencari bantuan melalui pusat bantuan di situs atau aplikasi Bukalapak.</p>
          </li>
        </ol>
      `,
    },
    {
      question: '<h3 class="ml-16 bl-text bl-text--subheading-20">Apa saja pemilihan metode pembayaran di EduKarier?</h3>',
      answer: `
        <p class="mb-20 ml-16 bl-text bl-text--body-16">Metode Pembayaran yang tersedia terdiri dari:</p>
        <ol class="mb-20 ml-16 pl-16">
          <li>
            <p class="bl-text bl-text--body-16">DANA</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">BukaDompet</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Transfer Virtual Account</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Kartu Visa/Mastercard/JCB/AMEX</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Cicilan Tanpa Kartu Kredit (Kredivo, AkuLaku)</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Indomaret / Alfamart</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Pos Indonesia</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">BRImo</p>
          </li>
        </ol>
        <p class="bl-text bl-text--body-16 ml-16">Opsi metode pembayaran dapat berubah sesuai dengan ketersediaan dan stabilitas yang ada.</p>
      `,
    },
    {
      question: '<h3 class="ml-16 bl-text bl-text--subheading-20">Bagaimana cara melakukan pembayaran di EduKarier?</h3>',
      answer: `
        <ol class="mb-20 ml-16 pl-16">
          <li>
            <p class="bl-text bl-text--body-16">Pilih Metode Pembayaran: Pada halaman pembayaran, Anda akan melihat opsi untuk memilih metode pembayaran.</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Konfirmasi Pembayaran: Setelah memilih metode bayar, periksa kembali detail pesanan Anda. Klik "Bayar" atau "Lanjutkan" untuk menyelesaikan proses pembayaran.</p>
          </li>
        </ol>
      `,
    },
    {
      question: '<h3 class="ml-16 bl-text bl-text--subheading-20">Bagaimana cara memulai kelas setelah pembayaran di EduKarier?</h3>',
      answer: `
         <ol class="mb-20 ml-16 pl-16">
          <li>
            <p class="bl-text bl-text--body-16">Akses Pelatihan: Setelah pembayaran berhasil, Anda akan menerima konfirmasi melalui email atau notifikasi di aplikasi Bukalapak. Anda bisa mengakses pelatihan yang telah dibeli melalui menu "Transaksi" atau "Pesanan Saya" di akun Bukalapak Anda.</p>
          </li>
          <li>
            <p class="bl-text bl-text--body-16">Mulai Pelatihan: Ikuti instruksi yang diberikan untuk memulai pelatihan. Biasanya, Anda akan diarahkan ke platform penyedia pelatihan untuk mengakses materi dan mengikuti kelas.</p>
          </li>
           <li>
            <p class="bl-text bl-text--body-16">Jika mengalami kendala, Anda bisa menghubungi layanan pelanggan Bukalapak atau mencari bantuan melalui pusat bantuan di situs atau aplikasi Bukalapak.</p>
          </li>
        </ol>
      `,
    },
    {
      question: '<h3 class="ml-16 bl-text bl-text--subheading-20">Bagaimana cara menghubungi Customer Service Bukalapak?</h3>',
      answer: `
        <p class="bl-text bl-text--body-16 ml-16">Anda bisa mengubungi Buka Bantuan dengan mengakses link berikut <a href="https://bukabantuan.bukalapak.com">https://bukabantuan.bukalapak.com</a> dan sampaikan pertanyaan/keluhan Anda.</p>
      `,
    },
    {
      question:
        '<h3 class="ml-16 bl-text bl-text--subheading-20">Apa yang harus dilakukan jika mengalami kesulitan teknis selama kelas berlangsung?</h3>',
      answer: `
        <p class="bl-text bl-text--body-16 ml-16">Saat mengikuti pelatihan, pastikan koneksi internet yang stabil dan pastikan memasukkan email dan kode voucher.</p>
        <p class="bl-text bl-text--body-16 ml-16 mt-16">Jika masih mengalami kendala, hubungi customer service Lembaga Pelatihan sesuai dengan pelatihan yang ingin kamu beli. Customer Service Lembaga Pelatihan tertera di detail halaman pelatihan di Bukalapak.</p>
      `,
    },
  ],
};
